import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LinkStyled from "shared/ui/LinkStyled";
import LoginForm from "../components/LoginForm";
import AuthCardLayout from "../components/AuthCardLayout";

const LoginSchools = () => {

    return (
        <Grid container spacing={4} justifyContent="center">
            <AuthCardLayout image="/images/account-type-1.svg" title="Brio în școli" size="large" showBackButton={true}>
                <LoginForm type="school"/>
                <LinkStyled to="/resetare-parola">Am uitat parola</LinkStyled>
                <Box mb={1.5}/>
                <LinkStyled to="/inregistrare">Creează cont de școală pentru profesor cu voucher</LinkStyled>
            </AuthCardLayout>
        </Grid>
    );
}

export default LoginSchools;